import React from "react";
import { Metric, MetricsContainer } from "./TableMetrics.styles";
import type { TableMetricsProps } from "./TableMetrics.types";

const TableMetrics: React.FC<TableMetricsProps> = ({ items }) => (
  <MetricsContainer>
    {items.map((item) => (
      <Metric key={item.label}>
        <span>{item.label}:</span>
        <strong>{item.value}</strong>
      </Metric>
    ))}
  </MetricsContainer>
);

export default TableMetrics;
